/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Absences_Create_Recurrence_IntervalInputs */

const en_forms_absences_create_recurrence_interval = /** @type {(inputs: Forms_Absences_Create_Recurrence_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurrence Interval`)
};

const de_forms_absences_create_recurrence_interval = /** @type {(inputs: Forms_Absences_Create_Recurrence_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholung Intervall`)
};

/**
* | output |
* | --- |
* | "Recurrence Interval" |
*
* @param {Forms_Absences_Create_Recurrence_IntervalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_absences_create_recurrence_interval = /** @type {((inputs?: Forms_Absences_Create_Recurrence_IntervalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Absences_Create_Recurrence_IntervalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_absences_create_recurrence_interval(inputs)
	return de_forms_absences_create_recurrence_interval(inputs)
});